import { Check } from 'lucide-react';
import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * A ticked reassurance line. Used on paper in the audience section and on
 * oxblood in the security band — which is the whole reason it reads its
 * colours from the surrounding surface context rather than naming them.
 */
export function CheckRow({
    children,
    className,
    ...props
}: ComponentProps<'div'> & { children: ReactNode }) {
    return (
        <div
            {...props}
            className={cn(
                'flex items-start gap-3 rounded-[12px] border border-border bg-background px-4 py-3 text-[14px] leading-[1.5] text-foreground',
                className,
            )}
        >
            <Check
                aria-hidden="true"
                className="mt-[2px] size-4 shrink-0 text-primary"
            />
            <span>{children}</span>
        </div>
    );
}
